'use client';
import tocbot from 'tocbot';
import { useEffect, useRef, useState } from 'react';
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { LuTableOfContents } from 'react-icons/lu';

export function TableOfContent({
  locale,
  onClick,
  hiddenTitle,
}: {
  locale: Locales;
  onClick?: (e: MouseEvent) => void;
  hiddenTitle?: boolean;
}) {
  const tocbotElement = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (tocbotElement.current) {
      tocbot.init({
        tocElement: tocbotElement.current,
        contentSelector: 'article.lexical-content',
        headingSelector: 'h2, h3, h4',
        collapseDepth: 3,
        scrollSmooth: true,
        scrollSmoothOffset: -80,
        headingsOffset: 80,
        enableUrlHashUpdateOnScroll: false,
        //positionFixedSelector: '#fixed-sidebar',
        //fixedSidebarOffset: 'auto',
        //ignoreSelector: '.no-toc',
        onClick: onClick,
      });
    }

    setTimeout(() => {
      tocbot.refresh();
    }, 2000);

    return () => {
      tocbot.destroy();
    };
  }, [onClick]);

  return (
    <section className="w-full py-4 pr-4 flex flex-col rounded-sm bg-stone-100 dark:bg-stone-900 min-h-0 flex-1">
      {!hiddenTitle && (
        <div className="w-full pl-4 shrink-0">
          <h2 className="text-lg mb-3 pb-2 border-b-2 border-dotted border-stone-300 dark:border-stone-700">
            {locale === 'ja' ? '目次' : 'Table of Contents'}
          </h2>
        </div>
      )}
      <div className="w-full flex-1 min-h-0 overflow-y-auto">
        <div ref={tocbotElement} className="w-full tocbot"></div>
      </div>
    </section>
  );
}

export function TableOfContentDialogMobile({ locale }: { locale: Locales }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          variant="secondary"
          className="fixed bottom-4 left-4 z-70 text-base border border-stone-300 dark:border-stone-600 lg:hidden"
        >
          <LuTableOfContents className="mr-2" />
          {locale === 'ja' ? '目次' : 'TOC'}
        </Button>
      </DialogTrigger>
      <DialogContent
        aria-describedby={undefined}
        className="!max-w-[90vw] !w-full !max-h-[85vh] bg-stone-100 dark:bg-stone-900 p-0 flex flex-col overflow-hidden"
      >
        <DialogHeader className="shrink-0">
          <DialogTitle className="text-lg text-left border-b border-stone-300 dark:border-stone-700 p-4">
            {locale === 'ja' ? '目次' : 'Table of Contents'}
          </DialogTitle>
        </DialogHeader>
        <div className="px-4 pb-4 flex-1 min-h-0 overflow-hidden flex flex-col">
          <TableOfContent locale={locale} hiddenTitle onClick={() => setIsOpen(false)} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
